import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CurrencyForUserReferenceService extends BaseReferenceService {
  constructor() {
    super('CurrencyReference');
  }
}
